export default __webpack_public_path__ + "static/future-45ccf1483951a6e03b3a5397499b818c.svg";